/**
 * Salvaged gun parts. The common crafting material, pulled off whatever stopped working first.
 */

import type { JunkItem } from '@/sim/items/itemContract';

export const SALVAGED_GUN_PARTS = {
  id: 'salvagedGunParts',
  kind: 'junk',
  label: 'Salvaged gun parts',
  description: 'Springs, pins and one trigger group. None of it Halcyon, whatever the seller said.',
  rarity: 'common',
  weightKg: 0.35,
  stackLimit: 40,
  equip: null,
  scrapValue: 9,
} as const satisfies JunkItem;
